module.exports = __webpack_public_path__ + "static/predefine_template_4-317552946f81a394b35bc984a5e03460.png";